"use strict";

module.exports = require("./NetworkService");